let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c9GqO")).then(() => parcelRequire('ioUY8'));